<template>
  <div class="component-content configuration-wheels">
    <div class="component-content-scroll">
      <div class="component-content-title mb-4">Select your wheels</div>

      <option-list
        :options="wheelsInput"
        :target="this.results.wheels"
        :inputName="'setpost'"
        v-on:target-updated="updateData"
      ></option-list>
    </div>
    <div class="buttonset">
      <button class="btn btn-outline-dark back-button" v-on:click="goBack">
        back
      </button>
      <finish-configuration-button
        v-if="canFinishConfiguration()"
        v-on:finish-configuration="finishConfiguration"
       ></finish-configuration-button>
      <button class="btn btn-outline-dark next-button" v-on:click="goNext">
        next
      </button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import OptionList from "../../shared/optionList.vue";
import FinishConfigurationButton from './finish-configuration-button.vue';

Vue.component("finish-configuration-button", FinishConfigurationButton);

export default {
  name: "configuration-wheels",
  data() {
    return {};
  },
  components: {
    OptionList,
  },
  props: ["configuratorSteps", "currentStep", "results", "components"],
  methods: {
    goNext: function () {
      if (this.results.wheels==null) {
        this.$emit('set-error', 'Please select a wheel');
        return false;
      }
      this.$emit("go-next");
    },
    goBack: function () {
      this.$emit("go-back");
    },
    updateData: function (e) {
      this.wheelsInput = e;
    },
    canFinishConfiguration: function() {
// if fork is present, we need to check if the fork is selected and has a colour
        if (this.components.fork?.length > 0) 
        {
          return (
          this.results.frame !== null &&
          this.results.frame !== undefined &&
          this.results.colour !== null &&
          this.results.colour !== undefined &&
          this.results.fork !== null &&
          this.results.fork !== undefined
          );
        }
        else
        {
          // no fork, so we can finish configuration
          return (
            this.results.frame !== null &&
            this.results.frame !== undefined &&
            this.results.colour !== null &&
            this.results.colour !== undefined
          );
        }
    },
    finishConfiguration: function() {
        this.$emit("finish-configuration");
    },
  },
  computed: {
    wheelsInput: {
      get: function () {
        return this.components.wheels[0];
      },
      set: function (e) {
        this.$emit("set-wheels", e);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.configuration-wheels {
}
</style>

